









































































































































import { forgotPassword, resetPassword } from '@/shared/api'
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  inject,
  onBeforeMount,
} from '@vue/composition-api'
import { alertSymbol } from '@/shared/state-management/symbols'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'PagesForgotPassword',
  components: {
    PagesBtn: () => import('./components/Btn.vue'),
    CloseButton,
  },
  setup(props, context) {
    const $alert = inject(alertSymbol) as Function
    const data = reactive({
      valid: true,
      password: '',
      email: '',
      emailRules: [
        (v: string) => !!v || context.root.$t('forgotPassword.emailRequired'),
        (v: string) =>
          /.+@.+\..+/.test(v) || context.root.$t('forgotPassword.emailInvalid'),
      ],
    })

    const resetPasswordData = reactive({
      resetPasswordValid: true,
      token: '',
      newPassword: '',
      newPassword2: '',
    })

    const resetPasswordRules = reactive({
      tokenRules: [
        (v: string) => !!v || context.root.$t('forgotPassword.tokenRequired'),
      ],
      newPasswordRules: [
        (v: string) =>
          (!!v && v.length >= 8) ||
          context.root.$t('login.password.invalid_length'),
        (v: string) => {
          const result = v.match(/^.*(?=\S*[\W]).*$/)
          return (
            (result && result.length && result[0] !== '') ||
            context.root.$t('login.password.specialCharacter')
          )
        },
      ],
      newPassword2Rules: [
        () =>
          resetPasswordData.newPassword === resetPasswordData.newPassword2 ||
          context.root.$t('forgotPassword.password2Mismatch'),
      ],
    })

    const form = ref(null)
    const resetPasswordForm = ref(null)
    const loadingData = ref(false)
    const userCode = ref('')
    const tokenRequested = ref(false)
    const sendingResetPasswordRequest = ref(false)

    const generateUserCode = (length: number) => {
      let result = ''
      const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        )
      }
      return result
    }

    const submitHandler = async () => {
      if (loadingData.value) {
        return
      }

      if (form.value) {
        form.value.validate()
      }
      if (!data.valid) {
        return
      }
      loadingData.value = true
      try {
        userCode.value = generateUserCode(30)
        await forgotPassword(data.email, userCode.value)
        $alert({
          text: context.root.$t('forgotPassword.emailSent', {
            email: data.email,
          }),
          type: 'success',
        })
        tokenRequested.value = true
        loadingData.value = false
      } catch (e) {
        loadingData.value = false
        throw e
      }
    }

    const resetPasswordHandler = async () => {
      if (sendingResetPasswordRequest.value) {
        return
      }

      resetPasswordForm.value.validate()
      sendingResetPasswordRequest.value = true
      try {
        await resetPassword(
          data.email,
          userCode.value,
          resetPasswordData.token,
          resetPasswordData.newPassword
        )
        sendingResetPasswordRequest.value = false
        $alert({
          text: context.root.$t('forgotPassword.success'),
          type: 'success',
        })
        context.root.$router.push({
          name: 'Login',
          params: { email: data.email },
        })
      } catch (e) {
        sendingResetPasswordRequest.value = false
        throw e
      }
    }

    onBeforeMount(() => {
      if (context.root.$route.params.email) {
        data.email = context.root.$route.params.email
      }
    })

    return {
      ...toRefs(data),
      ...toRefs(resetPasswordData),
      ...toRefs(resetPasswordRules),
      form,
      loadingData,
      submitHandler,
      tokenRequested,
      resetPasswordHandler,
      resetPasswordForm,
    }
  },
})
